export default "__VITE_ASSET__OuAosFQ5__"